import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_progress = _resolveComponent("el-progress");
  return _openBlock(), _createBlock(_component_el_progress, {
    percentage: _ctx.percentage,
    type: _ctx.type,
    "stroke-width": _ctx.strokeWidth,
    "text-inside": _ctx.textInside,
    "show-text": _ctx.showText,
    status: _ctx.status,
    color: _ctx.color,
    "data-test": _ctx.dataTest
  }, {
    default: _withCtx(() => [_ctx.$slots.default ? _renderSlot(_ctx.$slots, "default", {
      key: 0
    }) : _createCommentVNode("", true)]),
    _: 3
  }, 8, ["percentage", "type", "stroke-width", "text-inside", "show-text", "status", "color", "data-test"]);
}